import { Result } from '@/api/common/response/common.response';
import type { AddAssetRequest, EditAssetRequest } from '@/api/publicity/request/assets.request';
import type { AssetConfigDto } from '@/models';
import { HttpClient } from '@/services/HttpClient';
import axios from 'axios';
import { defineStore } from 'pinia';
import { useMainStore } from './main.store';

interface PublicityStore {
    addAssetCancelToken: any;
    assetsConfig: AssetConfigDto | null;
    showcaseMode: { active: boolean; deviceId: string | null; date: string | null };
}
export const usePublicityStore = defineStore('publicity', {
    persist: true,
    state: () =>
        ({
            addAssetCancelToken: null,
            assetsConfig: null,
            showcaseMode: {
                active: false,
                deviceId: null as string | null,
                date: null as string | null,
            },
        }) as PublicityStore,
    actions: {
        async addAsset(request: AddAssetRequest, xRequestId?: string) {
            const cancelToken = axios.CancelToken;
            this.addAssetCancelToken = cancelToken.source();
            return HttpClient.post<Result>('Assets', useMainStore().getData(request), {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'x-requestid': xRequestId,
                },
                cancelToken: this.addAssetCancelToken.token,
                timeout: 600000, // 600s = 10m
            });
        },

        cancelAddAsset() {
            this.addAssetCancelToken.cancel('canceled by user');
        },

        async updateAsset(request: EditAssetRequest, xRequestId?: string) {
            const cancelToken = axios.CancelToken;
            this.addAssetCancelToken = cancelToken.source();

            return HttpClient.put<Result>(`Assets/${request.id}`, useMainStore().getData(request), {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'x-requestid': xRequestId,
                },
                cancelToken: this.addAssetCancelToken.token,
                timeout: 600000, // 600s = 10m
            });
        },

        async activateShowcaseMode(
            active: boolean,
            deviceId: string | null = null,
            date: string | null = null
        ) {
            this.$patch({
                showcaseMode: {
                    active: active,
                    date: date,
                    deviceId: deviceId,
                },
            });
        },
    },
    getters: {
        isShowcaseModeOn: (state) => state.showcaseMode.active,
        showcaseParams: (state) => state.showcaseMode,
    },
});
